<udex-pagination *ngIf="pagination"
  [pages]="pagination.totalPages"
  type="full"
  display="mobile"
  (change)="onChange($event)"
  [currentPageIndex]="pagination.currentPage">
</udex-pagination>
